import {Routes} from '@angular/router';
import {HomePageComponent} from "./home-page/home-page.component";
import {Constants} from "./constants";
import {inject} from "@angular/core";
import {SeoService} from "./seo/seo.service";
import {TRACKING_ENABLED} from "./tracking/tracking";

export const routes: Routes = [
  {
    path: Constants.Routes.HOME,
    component: HomePageComponent,
    data: TRACKING_ENABLED,
    resolve: {
      firestoreStructuredData: async () => await inject(SeoService).getFirestoreStructuredData()
    }
  },
  {
    path: Constants.Routes.PRIVACY_POLICY,
    loadComponent: () => import("./privacy-policy-page/privacy-policy-page.component")
      .then(m => m.PrivacyPolicyPageComponent),
    title: `${Constants.Company.NAME} - Polityka Prywatności`
  },
  {
    path: Constants.Routes.DASHBOARD,
    loadChildren: () => import("./dashboard/dashboard.routes")
      .then(m => m.DASHBOARD_ROUTES),
  },
  {
    path: Constants.Routes.BLOG,
    data: TRACKING_ENABLED,
    loadChildren: () => import("./blog/blog.routes")
      .then(m => m.BLOG_ROUTES)
  },
  {
    path: Constants.Routes.OTHER,
    loadComponent: () => import("./not-found/not-found.component")
      .then(m => m.NotFoundComponent),
    title: `Nie znaleziono strony - ${Constants.Company.NAME}`
  }
];
